import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";

import { PIC } from "@ryde/assets";
import { FramerTooltip } from "@ryde/controls";
import { usePageContext } from "@ryde/redux";
import { tableSettingsDrawerAF, TOOLTIP_DELAY_BUTTONS } from "@ryde/shared";

import { EditGridColumnButtonStyled } from "./elements.styled";

export const EditGridColumnButton: FC = () => {
  const { entity } = usePageContext();
  const setTableLayoutDrawerState = useSetRecoilState(
    tableSettingsDrawerAF(entity),
  );
  const { t } = useTranslation();

  const onClick = (): void => {
    setTableLayoutDrawerState(true);
  };

  return (
    <EditGridColumnButtonStyled onClick={onClick}>
      <FramerTooltip
        content={t("general.MANAGE_COLUMNS")}
        mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
      >
        <PIC.EditGridColumnSVG className="EditGridColumnSVG" />
      </FramerTooltip>
    </EditGridColumnButtonStyled>
  );
};
